import { ethereumNames } from "../constants";
export function findEthereumNetwork(networks, networkAdapter, ethereumChainIds = []) {
    return networks.find(network => ethereumNames.includes(networkAdapter.getId(network))
        || ethereumChainIds.includes(Number(networkAdapter.getChainId(network))));
}
